module.exports = __webpack_public_path__ + "img/Logo 2019 website.4d506298.png";